// 7.2.2 IsArray(argument)
var cof = require('./_cof');
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};



//////////////////
// WEBPACK FOOTER
// ./~/async-validator/~/core-js/library/modules/_is-array.js
// module id = WqM/
// module chunks = 11